export enum AdditionalChoices {
  Text = 1,
  File = 2,
  Date = 3,
  Select = 4,
  Number = 5,
  CheckBox = 6,
  Link = 7,
  MultiSelect = 8,

}
